import num01 from '@/assets/svg/num_01.svg'
import num02 from '@/assets/svg/num_02.svg'
import num03 from '@/assets/svg/num_03.svg'
import num04 from '@/assets/svg/num_04.svg'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const SERVICE_BACKGROUND = 'eb0c7b060e7fa5170db79c3f98825805.png'

const SERVICE_ITEMS = [
  {
    numberImage: num01,
    phoneImage: '240bc1a2394245d7a21a3e8ec9f2772e.png',
    titleKey: 'sagawa.services.items.advanceBooking.title',
    hoverTextKeys: [
      'sagawa.services.items.advanceBooking.hover.safe',
      'sagawa.services.items.advanceBooking.hover.onTime',
      'sagawa.services.items.advanceBooking.hover.tracking',
      'sagawa.services.items.advanceBooking.hover.insurance',
    ],
  },
  {
    numberImage: num02,
    phoneImage: 'cdc9507ab7e36cb28682f28331638392.png',
    titleKey: 'sagawa.services.items.travelInformation.title',
    hoverTextKeys: [],
  },
  {
    numberImage: num03,
    phoneImage: '27922ba2e22859c3130b4f8fbf15f94c.png',
    titleKey: 'sagawa.services.items.handoverLuggage.title',
    hoverTextKeys: [],
  },
  {
    numberImage: num04,
    phoneImage: '8b26929c39adbcb35e9f7a50b3cd7ef5.png',
    titleKey: 'sagawa.services.items.deliveryTracking.title',
    hoverTextKeys: [],
  },
] as const

const ServiceContent = () => (
  <section
    className="h-[935px] w-full overflow-hidden rounded-[80px_0_0_0] bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: `url(${preFixImgUrl(SERVICE_BACKGROUND)})` }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col items-center pt-[60px]">
      <div className="flex flex-col items-center">
        <LangText
          lngKey="sagawa.services.title"
          className="text-[36px] font-bold leading-[50px] text-white"
        />
        <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-[#E0E0E0]/20" />
      </div>

      <div className="mt-[36px] grid w-full grid-cols-4 gap-[24px]">
        {SERVICE_ITEMS.map((item) => (
          <article key={item.titleKey} className="flex flex-col items-center min-w-0 group">
            <div className="flex h-[60px] items-center justify-center">
              <img src={item.numberImage} alt="" className="object-contain w-auto h-full" aria-hidden />
            </div>
            <LangText
              lngKey={item.titleKey}
              className="mt-[-2px] font-smiley-sans text-[32px] font-medium leading-[38px] text-white"
            />

            <div className="relative mt-[36px] h-[538px] w-[265px] overflow-hidden">
              <img
                src={preFixImgUrl(item.phoneImage)}
                alt=""
                className="absolute inset-0 z-[1] h-full w-full object-contain"
                draggable={false}
              />

              <div
                className="absolute z-[2] overflow-hidden"
                style={{ top: 12, right: 12, bottom: 8, left: 12, borderRadius: 36 }}
              >
                <div className="absolute inset-x-0 bottom-0 h-[46%] translate-y-full bg-linear-to-b from-[#328BF8]/0 via-[#328BF8]/70 to-[#328BF8] opacity-0 transition-[transform,opacity] duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100">
                  {item.hoverTextKeys.length > 0 && (
                    <div className="grid h-full grid-cols-2 content-end gap-x-[12px] gap-y-[12px] px-[14px] pb-[30px]">
                      {item.hoverTextKeys.map((hoverTextKey) => (
                        <div
                          key={hoverTextKey}
                          className="flex items-center gap-[6px] whitespace-nowrap text-white"
                        >
                          <span className="flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-white text-[14px] font-bold text-primary">
                            ✓
                          </span>
                          <LangText lngKey={hoverTextKey} className="text-[16px] leading-[22px]" />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default ServiceContent
